/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Import_File_Not_UsableInputs */

const en_error_import_file_not_usable = /** @type {(inputs: Error_Import_File_Not_UsableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This file cannot be imported. Choose it again and retry.`)
};

/**
* | output |
* | --- |
* | "This file cannot be imported. Choose it again and retry." |
*
* @param {Error_Import_File_Not_UsableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_import_file_not_usable = /** @type {((inputs?: Error_Import_File_Not_UsableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Import_File_Not_UsableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_import_file_not_usable(inputs)
});